<template>
  <div>
    <RelatedDocumentsItem v-for="data in relatedDocumentsControl" :v-key="data.id" :item="data"></RelatedDocumentsItem>
  </div>
</template>

<script>
  import {mapState} from 'vuex'
  import RelatedDocumentsItem from '@/components/RelatedDocumentsItem'

  export default {
    components: {RelatedDocumentsItem},
    data() {
      return {}
    },
    mounted() {
      this.$store.dispatch('Docflow/getRelatedDocumentsControl', this.$route.params.documentId)
    },
    computed: {
      ...mapState('Docflow', ['relatedDocumentsControl'])
    }
  }
</script>